import { Box, Button, Typography, useMediaQuery } from "@mui/material";
import Joyride, { TooltipRenderProps } from "react-joyride";
import { AnimatePresence, motion } from "framer-motion";

import PlanificationAssistance from "../../components/PlanificationAssistance/PlanificationAssistance";
import AssistanceAdjust from "../../components/AssistanceAdjust/AssistanceAdjust";
import NursingFunctions from "../../components/NursingFunctions/NursingFunctions";
import { ReactComponent as EnterKey } from "../../assets/icons/enter_key.svg";
import { ReactComponent as EscKey } from "../../assets/icons/esc_key.svg";
import PatientsList from "../../components/PatientsList/PatientsList";
import { HomeProvider, useHomeContext } from "./HomeProvider";
import Dashboard from "../../components/Dashboard/Dashboard";
import Sidebar from "../../components/Sidebar/Sidebar";
import { PageState, transition } from "./HomeUtils";
import Header from "../../components/Header/Header";
import "./Home.scss";

function Tooltip({ primaryProps, skipProps, step, tooltipProps }: TooltipRenderProps) {
	const width = step.styles.options.width;
	const zIndex = step.styles.options.zIndex;

	return (
		<Box
			{...tooltipProps}
			bgcolor={"white"}
			overflow={"hidden"}
			className="onboarding__container"
			width={width}
			zIndex={zIndex}
		>
			<Box>
				{step.title && (
					<Typography className="onboarding__subtitle">{step.title}</Typography>
				)}
				{step.content && <Box className="onboarding__body">{step.content}</Box>}
			</Box>
			<Box className="onboarding__buttons">
				<Button
					{...skipProps}
					className="onboarding__buttons__skip"
				>
					<EscKey />
					Omitir
				</Button>
				<Button
					{...primaryProps}
					className="onboarding__buttons__next"
				>
					<EnterKey />
					Siguiente
				</Button>
			</Box>
		</Box>
	);
}

function CustomJoyride() {
	const {
		joyrideRef,
		joyrideCallback,
		runOnboarding,
		stepIndex,
		steps,
		currentVariantSidebar,
		pageState,
	} = useHomeContext();

	const BreakpointLg = useMediaQuery("(max-width: 1900px)");

	const variantsSidebar = {
		hidden: {
			x: -300,
			width: "0%",
		},
		visible: {
			x: 0,
			width: BreakpointLg ? "12.5rem" : "16rem",
		},
	};

	return (
		<>
			<Joyride
				ref={joyrideRef}
				callback={joyrideCallback}
				continuous
				run={runOnboarding}
				stepIndex={stepIndex}
				steps={steps}
				tooltipComponent={Tooltip}
			/>
			<Box className="home">
				<AnimatePresence initial={false}>
					<motion.div
						animate={currentVariantSidebar}
						variants={variantsSidebar}
						transition={transition}
					>
						<Sidebar />
					</motion.div>
				</AnimatePresence>
				<Box className="home__main">
					<Header />
					{pageState === PageState.AssistanceAdjust && <AssistanceAdjust />}
					{pageState === PageState.Patients && (
						<Box className="home__body">
							<PatientsList />
						</Box>
					)}
					{pageState === PageState.PlanificationAssistance && (
						<Box className="home__body">
							<PlanificationAssistance />
						</Box>
					)}
					{pageState === PageState.NursingFunctions && <NursingFunctions />}
					{pageState === PageState.Dashboard && <Dashboard />}
				</Box>
			</Box>
		</>
	);
}

export default function Home() {
	return (
		<HomeProvider>
			<CustomJoyride />
		</HomeProvider>
	);
}
